import { Anchor } from "../anchor/Anchor.js";
import { Modal } from "../modal/Modal.js";
import { coreComponents } from "./Shared.js";
import { useCallback, useState } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Trans } from "react-i18next";

//#region src/components/rich-text/RichText.tsx
const RichText = ({ components = {}, richComponents = {}, text, values = {} }) => {
	const [visibleModals, setVisibleModals] = useState([]);
	const closeModal = useCallback((name) => {
		setVisibleModals((prev) => prev.filter((i) => i !== name));
	}, [setVisibleModals]);
	const toggleModal = useCallback((name) => {
		setVisibleModals((prev) => {
			if (prev.includes(name)) return prev.filter((i) => i !== name);
			return [...prev, name];
		});
	}, [setVisibleModals]);
	const extras = Object.entries(richComponents).reduce((acc, [name, compDef]) => {
		if (compDef.type === "modal") {
			const { size, title, body } = compDef.props;
			return {
				components: {
					...acc.components,
					[name]: /* @__PURE__ */ jsx(Anchor, { onClick: () => toggleModal(name) })
				},
				modals: [...acc.modals, /* @__PURE__ */ jsx(Modal, {
					opened: visibleModals.includes(name),
					title: title ?? void 0,
					size,
					onClose: () => closeModal(name),
					children: body.map(({ key, ...line }) => /* @__PURE__ */ jsx(RichText, { ...line }, key))
				}, name)]
			};
		}
		return acc;
	}, {
		components: {},
		modals: []
	});
	if (!text) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Trans, {
		ns: "dynamic",
		defaults: text,
		components: {
			...components,
			...coreComponents,
			...extras.components
		},
		values
	}), extras.modals.length ? extras.modals : null] });
};

//#endregion
export { RichText };